module.exports = __webpack_public_path__ + "img/felicitaciones-celular.1acb9361.jpg";